export const getFile = async (url: string, assetFileName?: string): Promise<File> => {
  const res = await fetch(url)
  const blob = await res.blob()

  const fileNameFromRespHeaders = res.headers
    .get('content-disposition')
    ?.split('filename=')[1]
    .replaceAll('"', '')

  const fileName = assetFileName ?? fileNameFromRespHeaders

  if (!fileName) throw new Error('Could not get file name from response')

  return new File([blob], fileName, { type: blob.type })
}
